import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Container,
	TextField,
} from "@material-ui/core";
import TextEditorComponent from "../textEditor/TextEditor";
import ImageUpload from "../../containers/upload/imageUpload";
import ResponsiveDatePicker from "../../../components/DatePicker";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
	cardRoot: {
		padding: "3vh 3%",
		"@media (max-width: 600px)": {
			padding: "3vh 0%",
			marginLeft: "-15px",
			width: "109%",
		},
	},
	cardContent: {
		display: "flex",
		flexDirection: "column",
	},
	cardActions: {
		display: "flex",
		justifyContent: "flex-end",
		paddingRight: "15px",
	},
	title: {
		margin: "10px 0",
	},
	input: {
		margin: "10px 0",
	},
}));

export default ({ title, onSubmit, openToast, isLoading, baseContentData }) => {
	const classes = useStyles();
	const [state, setState] = useState(
		baseContentData._id
			? {
					title: baseContentData.title,
					location: baseContentData.location,
					deadline: baseContentData.deadline,
					fileUrl: baseContentData.pdfUrl,
				}
			: {
					title: "",
					location: "",
					deadline: dayjs(),
					fileUrl: "",
				},
	);

	const handleChange = (event) => {
		const { id, value } = event.target;

		setState({ ...state, [id]: value });
	};
	const handleDateChange = (value) => {
		setState((prevState) => ({ ...prevState, deadline: value }));
	};

	const handleFileUploaded = (fileUrl) =>
		setState((prevState) => ({ ...prevState, fileUrl }));

	const handleSubmit = () => {
		state.deadline = state.deadline.format("YYYY-MM-DD");
		onSubmit(state);
	};

	return (
		<Container justify="center" maxWidth="md">
			<Card className={classes.cardRoot}>
				<CardHeader title={title || "Article Form"} />
				<CardContent className={classes.cardContent}>
					<TextField
						id="title"
						label="Title"
						variant="outlined"
						className={classes.title}
						value={state.title}
						onChange={handleChange}
						required
					/>
					<TextField
						id="location"
						label="Location"
						variant="outlined"
						className={classes.summary}
						value={state.location}
						onChange={handleChange}
						required
					/>
					<br />
					<ResponsiveDatePicker
						value={state.deadline}
						onValueChange={handleDateChange}
					/>

					<div className={classes.input}>
						<ImageUpload
							onFileUploaded={handleFileUploaded}
							isFileUpload
							defaultImg={state.fileUrl}
						/>
					</div>
				</CardContent>
				<CardActions className={classes.cardActions}>
					<Button
						variant="outlined"
						onClick={handleSubmit}
						sx={{
							color: "#E00186",
							border: "1px solid #E00186",
							"&:hover": {
								color: "#fff",
								backgroundColor: "#E00186",
								border: "1px solid #E00186",
							},
						}}
					>
						{isLoading ? "Saving..." : "Save Work"}
					</Button>
				</CardActions>
			</Card>
		</Container>
	);
};
